
import { reactive} from "vue";
import DynamicForm from "@/components/Shared/Dynamicform/DynamicForm.vue";

export default {
  name: "WildBookObserveData",
  inheritAttrs: false,
  components: {
    DynamicForm
  },
  setup() {
    const request = reactive({
      apiLoadMethod: "",
      apiSaveMethod: "",
      form: "WildbuchEintragBeobachtung",
      page: "WildbuchEintragBeobachtungDaten",
      remoteId: "",
      
      

    });
    return {
      request
    };
  }
};
